/* RESPONSIBLE TEAM: team-knowledge-foundations */
import Model, { attr } from '@ember-data/model';
import { type EntityType } from '../data/entity-types';
import type ContentFragment from './content-fragment';

export default class ContentImportRunRecordWrapper extends Model {
  @attr('string') declare appId: string;
  @attr('string') declare title: string;
  @attr() declare audienceTypes: Array<any>;
  @attr() declare contents: Array<any>; // Keep as raw array, not hasMany relationship
  @attr() declare relations: any;
  @attr() declare tags: Array<any>;
  @attr('number') declare priority: number;
  @attr('array') declare highlightedTitle: any[];
  @attr('array') declare highlightedBody: any[];

  get entityType(): EntityType {
    return this.contents?.[0]?.content_type;
  }

  get entityId(): number | undefined {
    return this.contents?.[0]?.content_id;
  }

  get contentReviewSuggestionMetadata() {
    return this.contents?.[0]?.content_data?.suggestion_metadata ?? {};
  }

  get contentReviewType() {
    return this.contents?.[0]?.content_review_type;
  }

  get contentReviewSuggestionText() {
    return this.contents?.[0]?.content_review_suggestion_text;
  }

  get contentData() {
    return this.contents?.[0]?.content_data;
  }

  // Required methods for UI compatibility
  allContentIncludedIn(_fragments: Set<ContentFragment>): boolean {
    return false; // ContentImportRunRecord shouldn't be selectable in bulk actions
  }

  anyContentIncludedIn(_fragments: Set<ContentFragment>): boolean {
    return false; // ContentImportRunRecord shouldn't be selectable in bulk actions
  }
}
